import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext, useEffect } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Chart from '@reuters-graphics/vaccination-cumulative';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';

const atlas = new AtlasMetadataClient();

const chart = new Chart();

const CumulativeChartContainer = (props) => {
  const { vaccinationData } = props;

  const chartContainer = React.createRef();

  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);

  useEffect(() => {
    chart
      .selection(chartContainer.current)
      .data(vaccinationData.totalDoses)
      .props({
        height: 200,
        strokeWidth: 3,
        stroke: '#A3BE8C',
        areaFill: 'rgba(163, 190, 140, 0.5)',
        // baseStroke: '#CBCCCF',
        countryISO: atlas.getCountry(countrySlug).isoAlpha2,
        milestones: [0.01, 0.05, 0.1, 0.2, 0.3, 0.4, 0.5],
        margin: {
          left: 0,
          right: 40,
          axis: 20,
        },
        text: {
          milestone: content.template.vaccination.chart.milestone.major,
          milestoneMinor: content.template.vaccination.chart.milestone.minor,
          daysLabel: content.template.vaccination.chart.daysLabel,
        },
        milestoneStyle: {
          stroke: 'rgba(255,255,255,0.75)',
          'stroke-dasharray': '5,5',
          textFill: 'rgba(255,255,255,0.75)',
        },
      })
      .draw();
  }, [vaccinationData, countrySlug, chartContainer, content]);

  const resize = debounce(() => {
    if (!chartContainer.current) return;
    chart.draw();
  }, 250);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component)}>
      <div className='vaccination-cumulative-container' ref={chartContainer} />
    </div>
  );
};

export default CumulativeChartContainer;
